var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"block panel wrapper-lg bg-info item"},[_c('i',{staticClass:"fa-fw text-3x text-white m-r-xs",class:_vm.icon}),_c('span',{staticClass:"text-white font-thin h2 block m-t-sm"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-muted text-md m-t-sm"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }